import React from 'react';
import './CouponAnalyticsModal.css';

const CouponAnalyticsModal = ({ coupon, onClose }) => {
  if (!coupon) return null;

  const topCustomers = [
    { name: 'Ali Ahmed', timesUsed: 3, amountSaved: 600 },
    { name: 'Sara Khan', timesUsed: 2, amountSaved: 400 },
    { name: 'Ahmed Hassan', timesUsed: 2, amountSaved: 400 }
  ];

  const recentOrders = [
    { id: '#12345', customer: 'Ali Ahmed', date: '2024-12-10', amount: 1200, discount: 200 },
    { id: '#12344', customer: 'Sara Khan', date: '2024-12-09', amount: 800, discount: 200 },
    { id: '#12343', customer: 'Ahmed Hassan', date: '2024-12-08', amount: 1000, discount: 200 }
  ];

  return (
    <div className="analytics-modal-overlay" onClick={onClose}>
      <div className="analytics-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Coupon Analytics - {coupon.code}</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="modal-content">
          {/* Overview Cards */}
          <div className="overview-cards">
            <div className="overview-card">
              <div className="overview-label">Total Redemptions</div>
              <div className="overview-value">{coupon.totalRedemptions || coupon.timesUsed}</div>
            </div>
            <div className="overview-card">
              <div className="overview-label">Unique Customers</div>
              <div className="overview-value">{topCustomers.length}</div>
            </div>
            <div className="overview-card">
              <div className="overview-label">Revenue Impact</div>
              <div className="overview-value">PKR {(coupon.revenueImpact / 1000).toFixed(0)}K</div>
            </div>
          </div>

          {/* Usage Chart Placeholder */}
          <div className="chart-section">
            <h3 className="section-title">Usage Over Time</h3>
            <div className="chart-placeholder">
              <p>Chart visualization would appear here</p>
              <p className="chart-note">Line chart showing daily redemptions</p>
            </div>
          </div>

          {/* Top Customers */}
          <div className="top-customers-section">
            <h3 className="section-title">Top Customers</h3>
            <div className="customers-table">
              <table>
                <thead>
                  <tr>
                    <th>Customer Name</th>
                    <th>Times Used</th>
                    <th>Amount Saved</th>
                  </tr>
                </thead>
                <tbody>
                  {topCustomers.map((customer, index) => (
                    <tr key={index}>
                      <td>{customer.name}</td>
                      <td>{customer.timesUsed}</td>
                      <td>PKR {customer.amountSaved}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Recent Orders */}
          <div className="recent-orders-section">
            <h3 className="section-title">Orders with Coupon</h3>
            <div className="orders-list">
              {recentOrders.map((order, index) => (
                <div key={index} className="order-item">
                  <div className="order-id">{order.id}</div>
                  <div className="order-details">
                    <span>{order.customer}</span>
                    <span>•</span>
                    <span>{new Date(order.date).toLocaleDateString()}</span>
                    <span>•</span>
                    <span>PKR {order.amount}</span>
                    <span>•</span>
                    <span className="discount">-PKR {order.discount}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="footer-btn close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CouponAnalyticsModal;

